import React from "react";
import { Portal } from "../Portal/Portal";
import styles from "./AnnouncementModal.module.css";

interface AnnouncementModalProps {
  isOpen: boolean;
  announcement: string;
  onClose: () => void;
}

export const AnnouncementModal: React.FC<AnnouncementModalProps> = ({
  isOpen,
  announcement,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <Portal>
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <div className={styles.content}>
            <div className={styles.announcement}>{announcement}</div>

            <button className={styles.closeButton} onClick={onClose}>
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </Portal>
  );
};
